import { FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM, FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM_ON } from "./consts";

/**
 * HL-12814: initial state of the Fast Doctor Approval toggle on the Flowzz Choose Treatment (arm B).
 * - No offer (arm A, Premium, no express doctor): off, the card is not rendered anyway.
 * - The user already decided on this cart (toggle touched here or on Shipping): the cart's flag wins.
 * - Otherwise `fda=1` on the Flowzz link pre-selects the toggle; no `fda` or `fda=0` leaves it off.
 */
export const getFlowzzFastApprovalInitialToggle = ({
  isOffer,
  searchParams,
  cartFlag,
  userDecided,
}: {
  isOffer: boolean;
  searchParams: URLSearchParams;
  cartFlag: boolean | number | null | undefined;
  userDecided: boolean;
}): boolean => {
  if (!isOffer) return false;
  if (userDecided || cartFlag) return Boolean(cartFlag);
  return searchParams.get(FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM) === FLOWZZ_FAST_DOCTOR_APPROVAL_PARAM_ON;
};

/** sessionStorage key remembering that the user touched the toggle for this cart. */
export const flowzzFastApprovalDecidedKey = (cartId: number | string | null | undefined) => `flowzz_fast_approval_decided_${cartId ?? "none"}`;
